import { WorkspaceRole } from '../../../../../../api/workspaces/getWorkspaceMembers';
import { OperationPermissionConfig, PermissionsByBetaStatus } from '../types';
import { extractPermissionByBetaStatus } from './extractPermissionByBetaStatus';
import { extractPermissionByProStatus } from './extractPermissionByProStatus';
import { extractPermissionByMemberType } from './extractPermissionsByMemberType';

interface ExtractPermissionFromConfigParams {
  isBetaUser: boolean;
  isPro: boolean;
  workspaceMemberType: WorkspaceRole;
}

export type WorkspacePermissionItemParams = [
  keyof OperationPermissionConfig,
  PermissionsByBetaStatus
];

/**
 * Given a particular Operation Permission, what is the effective setting?
 */
export const extractEffectiveOperationPermission =
  ({
    isBetaUser,
    isPro,
    workspaceMemberType,
  }: ExtractPermissionFromConfigParams) =>
  ([operationName, permissionsByBetaStatus]: WorkspacePermissionItemParams) => {
    const permissionsByProStatus = extractPermissionByBetaStatus({
      isBetaUser: isBetaUser,
      permissionsByBetaStatus: permissionsByBetaStatus,
    });

    // pro or non pro?
    const permissionsByMemberType = extractPermissionByProStatus({
      permissionsByProStatus: permissionsByProStatus,
      isPro: isPro,
    });

    // which permission?
    const effectivePermission = extractPermissionByMemberType({
      workspaceMemberType,
      permissionsByMemberType,
    });

    return [operationName, effectivePermission] as const;
  };
